export const nameTypes = {
    PRODUCTS:"products",
    CATEGORIES:"categories"
}
export const ActionTypes = {
    LOAD_DATA:"load_data",
    ADD_CART:"add_cart",
    REMOVE_ITEM:"remove_item"
}